import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { ProvisionalStatus } from '@ffd/api-client';

export type ProvisionalStatusIconType = 'health-history-item' | 'patient-alert';

@Component({
  selector: 'lib-health-history-item-provisional-status-icon',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, TooltipModule, TranslateModule],
  templateUrl: './health-history-item-provisional-status-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryItemProvisionalStatusIconComponent {
  public readonly provisionalStatus = input.required<ProvisionalStatus>();
  public readonly itemType = input.required<ProvisionalStatusIconType>();

  public readonly svgIconKey: Signal<SvgIcons> = computed(() => {
    switch (this.provisionalStatus()) {
      case ProvisionalStatus.CREATING: {
        return 'px-12-hourglass';
      }
      case ProvisionalStatus.EDITING: {
        return 'px-16-edit-pending';
      }
      case ProvisionalStatus.DELETING: {
        return 'px-16-delete-pending';
      }
      default: {
        return 'px-16-edit';
      }
    }
  });

  public readonly tooltipTextKey: Signal<string> = computed(() => {
    if (this.itemType() === 'health-history-item') {
      switch (this.provisionalStatus()) {
        case ProvisionalStatus.CREATING: {
          return 'health_history_health_history_tab_item_create_pending_tooltip';
        }
        case ProvisionalStatus.EDITING: {
          return 'health_history_health_history_tab_item_edit_pending_tooltip';
        }
        case ProvisionalStatus.DELETING: {
          return 'health_history_health_history_tab_item_delete_pending_tooltip';
        }
        default: {
          return '';
        }
      }
    } else {
      switch (this.provisionalStatus()) {
        case ProvisionalStatus.CREATING: {
          return 'patient_alerts_item_create_pending_tooltip';
        }
        case ProvisionalStatus.EDITING: {
          return 'patient_alerts_item_edit_pending_tooltip';
        }
        case ProvisionalStatus.DELETING: {
          return 'patient_alerts_item_delete_pending_tooltip';
        }
        default: {
          return '';
        }
      }
    }
  });
}
